export default __webpack_public_path__ + "static/media/tony-6.05480e1c.jpeg";